import { Route, RouteObject } from 'react-router-dom';
import { mxDashboardRoutes } from './dashboard';
import { mxDeviceManagementRoutes } from './device-management';
import { mxMeterReadsRoutes } from './meterReads';
import { mxValidationsRoutes } from './validations';
import { mxReadCycleManagementRoutes } from './readCycleManagement';
import { mxRouteManagementRoutes } from './routeManagement';
import { mxManufacturerRoutes } from './manufacturer';
import { mxSettingsRoutes } from './settings';
import { mxResourcesRoutes } from './resources/route';
import { mxOperationsRoutes } from './operations/routes';
import { mxReadsRoutes } from './reads/routes';

export interface mxRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: mxRoute[];
}

export const mxRoutes: mxRoute[] = [
  ...mxDashboardRoutes,
  ...mxDeviceManagementRoutes,
  ...mxReadCycleManagementRoutes,
  ...mxRouteManagementRoutes,
  ...mxValidationsRoutes,
  ...mxManufacturerRoutes,
  ...mxSettingsRoutes,
  ...mxResourcesRoutes,
  ...mxOperationsRoutes,
  ...mxReadsRoutes,
  ...mxReadsRoutes
];